import generateStore from './generateStore.js'

export default (app) => {
  const store = generateStore('messages', app)
  return store
}
